import { MissionKindEnum } from '@e-socna/data-layer';

import { FormVariant } from '../../enums/variant.enum';
import { MissionFormTab } from '../enums/tab.enum';

type FormKind = Readonly<{ kind: MissionKindEnum; formVariant: FormVariant }>;

// The actors of a sub-mission follow its quotation case (« Acteurs » step)
// instead of being edited one by one.
const HIDDEN_TABS_BY_KIND: Readonly<
  Record<MissionKindEnum, readonly MissionFormTab[]>
> = {
  [MissionKindEnum.Standard]: [MissionFormTab.SubMissionActors],
  [MissionKindEnum.Composite]: [
    MissionFormTab.Type,
    MissionFormTab.Collaboration,
    MissionFormTab.SubMissionActors,
  ],
  [MissionKindEnum.SubMission]: [
    MissionFormTab.InternalActors,
    MissionFormTab.ExternalActors,
  ],
};

const hiddenTabsOf = ({
  kind,
  formVariant,
}: FormKind): readonly MissionFormTab[] =>
  kind === MissionKindEnum.Standard && formVariant === FormVariant.Creation
    ? [...HIDDEN_TABS_BY_KIND[kind], MissionFormTab.Collaboration]
    : HIDDEN_TABS_BY_KIND[kind];

// The steps of the mission form: a collaboration has neither a type nor a
// collaboration; a simple mission is created without the collaboration step,
// an existing mission being attached or detached later; a sub-mission edits
// its actors through its quotation case. A collaboration and a sub-mission
// are created with their own forms.
export const isMissionFormTabShown = (
  tab: MissionFormTab,
  formKind: FormKind,
): boolean => !hiddenTabsOf(formKind).includes(tab);
